import {makeObservable, observable} from 'mobx';

import type {RichEditor} from '../../../uikit/RichEditor/types';
import type {Nullable} from '../../../utils/utility-types';
import type {ModelToProps} from '../Base/types';
import type {CategoryModel} from '../Category/Category.model';
import type {DateTimeModel} from '../Date/DateTime.model';
import type {FileModel} from '../File/File.model';

import {BaseModel} from '../Base/Base.model';

const ModelName = 'ArticleModel';

export class ArticleModel extends BaseModel {
  avatar: Nullable<FileModel> = null;
  categories: CategoryModel[] = [];
  content: RichEditor.Content = {};
  created: DateTimeModel;
  files: Nullable<FileModel>[] = [];
  isFeatured: boolean = false;
  status = ArticleModel.Status.DRAFT;
  subscription = ArticleModel.Subscription.FREE;
  textContent: string = '';
  timeToRead: number;
  title: string;
  type = ArticleModel.Type.ARTICLE;
  updated: DateTimeModel;

  constructor(props: ArticleModel.Props) {
    super(props);
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<ArticleModel, ArticleModel.Props>(props, {
        categories: observable.shallow,
        content: observable.ref,
        files: observable.shallow,
      }),
    );
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace ArticleModel {
  export enum Status {
    DRAFT = 'draft',
    HIDDEN = 'hidden',
    PUBLISHED = 'published',
  }

  export enum Subscription {
    FREE = 'free',
    PREMIUM = 'premium',
  }

  export enum Type {
    ARTICLE = 'article',
    AUDIO = 'audio',
    VIDEO = 'video',
  }

  export type Props = ModelToProps<ArticleModel>;
}
